module.exports = {"TXTCLI_Stakes":{"id":"TXTCLI_Stakes","defaultMessage":"Einsatz"}}